import '../styles/App.css';
import Banner from './Banner';
import Footer from './Footer';
import Welcome from './Welcome';
import Profile from './Profile';
import Skills from './Skills';
import Portfolio from './Portfolio';

function App() {
  return (

    <div>
    <Banner />
    <Welcome/>
    <Profile/>
    <Skills/>
    <Portfolio/>
    <Footer/>

</div>
  );
}

export default App;
